import { useRef, useState } from "react";

export default function FileInput({ question, value, onChange, error }) {
  const inputRef = useRef(null);
  const [dragOver, setDragOver] = useState(false);
  const [localError, setLocalError] = useState(null);

  const handleFile = (file) => {
    if (!file) return;

    const validation = question.validation || {};
    const maxBytes = validation.maxSizeMB
      ? validation.maxSizeMB * 1024 * 1024
      : null;
    const dotIndex = file.name.lastIndexOf(".");
    const ext = dotIndex > 0 ? file.name.slice(dotIndex).toLowerCase() : "";

    let message = null;
    if (maxBytes && file.size > maxBytes) {
      message = `Ukuran file maksimal ${validation.maxSizeMB}MB.`;
    } else if (validation.accept && !validation.accept.includes(ext)) {
      message = `Format yang diterima: ${validation.accept.join(", ")}.`;
    }

    if (message) {
      onChange(question.id, null);
      setLocalError(message);
      return;
    }

    setLocalError(null);
    onChange(question.id, file);
  };

  const handleChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files[0]);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const formatSize = (bytes) => {
    if (bytes < 1024) return bytes + " B";
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
    return (bytes / (1024 * 1024)).toFixed(1) + " MB";
  };

  return (
    <div className="flex flex-col gap-3">
      <div
        onDragOver={(e) => {
          e.preventDefault();
          setDragOver(true);
        }}
        onDragLeave={() => setDragOver(false)}
        onDrop={handleDrop}
        onClick={() => inputRef.current?.click()}
        className={`flex flex-col items-center justify-center gap-3 px-6 py-10 rounded-xl border-2 border-dashed
          cursor-pointer transition-all duration-300
          ${
            dragOver
              ? "border-white/60 bg-white/10"
              : value
                ? "border-white/30 bg-white/5"
                : "border-white/15 bg-white/[0.02] hover:bg-white/[0.06] hover:border-white/25"
          }`}
      >
        <i
          className={`fa-solid fa-cloud-arrow-up text-3xl transition-colors duration-300
            ${dragOver ? "text-white" : "text-white/40"}`}
        />
        {value ? (
          <div className="flex flex-col items-center gap-1">
            <p className="text-white font-sans text-sm font-medium">
              {value.name}
            </p>
            <p className="text-white/50 font-sans text-xs">
              {formatSize(value.size)}
            </p>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onChange(question.id, null);
              }}
              className="mt-1 text-red text-xs font-sans font-semibold hover:underline"
            >
              Hapus file
            </button>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-1">
            <p className="text-white/60 font-sans text-sm">
              Seret & lepas atau{" "}
              <span className="text-white font-semibold">pilih file</span>
            </p>
            <p className="text-white/30 font-sans text-xs">
              {question.validation?.accept?.join(", ") || "Any file"} • Max{" "}
              {question.validation?.maxSizeMB || "?"}MB
            </p>
          </div>
        )}
      </div>
      {localError && (
        <div className="flex items-center gap-2 mt-2">
          <i className="fa-solid fa-circle-exclamation text-red text-xs" />
          <p className="text-red text-xs font-sans font-medium">{localError}</p>
        </div>
      )}
      <input
        ref={inputRef}
        type="file"
        onChange={handleChange}
        accept={question.validation?.accept?.join(",")}
        className="hidden"
      />
    </div>
  );
}
